import PersonAlertIcon from 'assets/images/icons/PersonAlert.svg?react';
import Chip from 'components/@extended/Chip';
import { Tooltip } from 'components/ui/tooltip';
import { t } from 'utils/getTranslations';

interface Props {
    /** Pixel size of the inner SVG icon. The chip background scales to 1.5× this value. Defaults to 16. */
    iconSize?: number;
}

export default function PersonaNonGrataChip({ iconSize = 16 }: Props) {
    const chipSize = Math.round(iconSize * 1.5);
    return (
        <Tooltip
            side="bottom"
            content={
                <>
                    <div className="font-semibold">{t('contacts.suffix.persona-non-grata')}</div>
                    <div>{t('contacts.suffix.persona-non-grata-tooltip')}</div>
                </>
            }
        >
            <span className="inline-flex align-middle">
                <Chip
                    size="small"
                    type="personaNonGrata"
                    label={<PersonAlertIcon width={iconSize} height={iconSize} />}
                    style={{ height: chipSize, width: chipSize }}
                />
            </span>
        </Tooltip>
    );
}
